import React from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from '@fronton/icons-react';

export type ShortArrowProps = {
  direction?: Direction;
} & React.SVGProps<SVGSVGElement>;

type Direction = 'left' | 'right' | 'top' | 'bottom';

export const ShortArrow: React.FC<ShortArrowProps> = ({ direction = 'right' }) => {
  return direction === 'right' ? (
    <ChevronRightIcon type="outline" size="l" color="text-primary" />
  ) : (
    <ChevronLeftIcon type="outline" size="l" color="text-primary" />
  );
};
